import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/admin/AdminUI";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

function fmt(ts) {
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return ts;
  }
}

export default function AdminAudit() {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    api.get("/admin/audit-logs").then((r) => setLogs(r.data)).catch(() => setLogs(false));
  }, []);

  if (logs === null)
    return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
  if (logs === false) return <p className="text-sm text-destructive">Failed to load audit logs.</p>;

  return (
    <div data-testid="admin-audit">
      <PageHeader title="Audit Logs" subtitle="Recent activity across the platform" />
      <div className="rounded-2xl border border-border bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Action</TableHead>
              <TableHead>Actor</TableHead>
              <TableHead>Target</TableHead>
              <TableHead>When</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.map((l, i) => (
              <TableRow key={i} data-testid={`audit-row-${i}`}>
                <TableCell>
                  <Badge variant="outline" className="font-mono text-xs">{l.action}</Badge>
                </TableCell>
                <TableCell className="text-muted-foreground">{l.actor_email}</TableCell>
                <TableCell className="text-muted-foreground">{l.target || "—"}</TableCell>
                <TableCell className="text-muted-foreground">{fmt(l.created_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
